const config = {
  calculatorUrl: process.env.REACT_APP_BASE_CALCULATOR_API,
  mainUrl:process.env.REACT_APP_MAIN_API,
};
export default config;
